import type { TOC } from '@ember/component/template-only'
import RouteTemplate from 'ember-route-template'
import { BookLibrarySharesTable } from 'teacher-ui-client/components/book-library/shares-table'
import type BookLibrarySharesByCollectionController from 'teacher-ui-client/subscription-type/book-library/shares/index/by-collection/controller'

interface Signature {
  Args: {
    controller: BookLibrarySharesByCollectionController
  }
}
export const BookLibrarySharesIndexByCollectionPage: TOC<Signature> = <template>
  <BookLibrarySharesTable class="min-w-full table-fixed" @expandedShareId={{@controller.expandedShareId}}>
    <:expandedRow>{{outlet}}</:expandedRow>
  </BookLibrarySharesTable>
</template>

export default RouteTemplate(BookLibrarySharesIndexByCollectionPage)
